/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminEbayListingStatus = {
    EbayListingStatusDraft: 'draft',
    EbayListingStatusPublishing: 'publishing',
    EbayListingStatusActive: 'active',
    EbayListingStatusUpdating: 'updating',
    EbayListingStatusEnding: 'ending',
    EbayListingStatusEnded: 'ended',
    EbayListingStatusSold: 'sold',
    EbayListingStatusError: 'error'
} as const;
export type AdminEbayListingStatus = typeof AdminEbayListingStatus[keyof typeof AdminEbayListingStatus];


export function instanceOfAdminEbayListingStatus(value: any): boolean {
    for (const key in AdminEbayListingStatus) {
        if (Object.prototype.hasOwnProperty.call(AdminEbayListingStatus, key)) {
            if (AdminEbayListingStatus[key as keyof typeof AdminEbayListingStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminEbayListingStatusFromJSON(json: any): AdminEbayListingStatus {
    return AdminEbayListingStatusFromJSONTyped(json, false);
}

export function AdminEbayListingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayListingStatus {
    return json as AdminEbayListingStatus;
}

export function AdminEbayListingStatusToJSON(value?: AdminEbayListingStatus | null): any {
    return value as any;
}

export function AdminEbayListingStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminEbayListingStatus {
    return value as AdminEbayListingStatus;
}

